import { GlobalAction, VideosState, GLOBAL_ACTIONS } from '.';

const GET_VIDEO_START = 'GET_VIDEO_START';
const GET_VIDEO_ERROR = 'GET_VIDEO_ERROR';
const GET_VIDEO_SUCCESS = 'GET_VIDEO_SUCCESS';
const MERGE_VIDEO_START = 'MERGE_VIDEO_START';
const MERGE_VIDEO_ERROR = 'MERGE_VIDEO_ERROR';
const MERGE_VIDEO_SUCCESS = 'MERGE_VIDEO_SUCCESS';
const UPDATE_VIDEOS_SUCCESS = 'UPDATE_VIDEOS_SUCCESS';

export const videosReducer = (
  state: VideosState,
  action: GlobalAction
): VideosState => {
  const { payload, type } = action;
  switch (type) {
    case GET_VIDEO_SUCCESS:
    case UPDATE_VIDEOS_SUCCESS: {
      const { video } = payload;
      return {
        ...state,
        videos: { ...state.videos, [video.id]: video },
      };
    }
    case GLOBAL_ACTIONS.SET_LIBRARY_FOLDER: {
      return {
        ...state,
        mergeModal: { ...state.mergeModal, currentFolder: payload },
      };
    }
    case GLOBAL_ACTIONS.GET_VIDEOS_SUCCESS: {
      const { folder, videos, count, page, size, search } = payload;
      return {
        ...state,
        mergeModal: {
          ...state.mergeModal,
          library: {
            ...state.mergeModal.library,
            [folder]: {
              videos,
              count,
              page,
              size,
              search,
            },
          },
        },
      };
    }

    default:
      return state;
  }
};

export const VIDEOS_ACTIONS = {
  GET_VIDEO_START,
  GET_VIDEO_ERROR,
  GET_VIDEO_SUCCESS,
  MERGE_VIDEO_START,
  MERGE_VIDEO_ERROR,
  MERGE_VIDEO_SUCCESS,
};
